
import {
    defineComponent,
    toRef,
    watchEffect,
    onMounted,
    watch,
    ref
} from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import {
    TweenMax
} from "gsap";

export default defineComponent({
    name: "RightPanel",
    components: {
        CigoIconFont
    },
    setup(props) {
        let openClass = ref("close");
        let panelOpenFlag = toRef(
            CigoAdminStore.getState().systemState,
            "rightPanelOpen"
        );
        watch(panelOpenFlag, (openFlag: boolean, preOpenFLag: boolean) => {
            panelChange(openFlag);
        });

        onMounted(() => {
            tipPanelExist();
            panelChange(panelOpenFlag.value);
        });

        const hover = (flag: boolean) => {
            TweenMax.to(".right-panel-toggle", 0.5, {
                left: flag ? "-30px" : "-9px",
                opacity: flag ? 1 : 0.5
            });
        };

        const tipPanelExist = () => {
            setTimeout(() => {
                if (!panelOpenFlag.value) {
                    TweenMax.to(".right-panel-toggle", 0.8, {
                        left: "-30px",
                        opacity: 1,
                        onComplete: () => {
                            TweenMax.to(".right-panel-toggle", 0.8, {
                                left: "-9px",
                                opacity: 0.5,
                                delay: 2
                            });
                        }
                    });
                }
            }, 3000);
        };

        const panelChange = (openFlag: boolean) => {
            if (openFlag) {
                openClass.value = "open";
            } else {
                //TIPS 延迟标记，防止过早关闭导致背景半透明动画无效
                setTimeout(() => {
                    openClass.value = "close";
                }, 800);
            }
            TweenMax.to(".right-panel-bg", 0.8, {
                opacity: openFlag ? 0.8 : 0
            });
            TweenMax.to(".right-panel-toggle", 0.8, {
                opacity: openFlag ? 1 : 0.5
            });
            if (openFlag) {
                TweenMax.to(".right-panel-content", 0.4, {
                    width: "200px",
                    onStart: () => {
                        TweenMax.to(".right-panel-content", 0.5, {
                            opacity: 1
                        });
                    }
                });
            } else {
                TweenMax.to(".right-panel-content", 0.4, {
                    opacity: 0,
                    onStart: () => {
                        TweenMax.to(".right-panel-content", 0.5, {
                            width: "0px"
                        });
                    }
                });
            }
        };

        return {
            CigoAdminStore,
            hover,
            openClass,
            panelOpenFlag
        };
    }
});
